const filterMappedAssignments = ({
  assessmentItemId,
  assessmentItems,
  assignments,
}) => {
  if (!assessmentItemId) {
    return [];
  }

  const selectedAssessmentItem = assessmentItems.find(
    ({ id }) => id === assessmentItemId
  );

  if (!selectedAssessmentItem) {
    return [];
  }

  const mappedAssignmentsIds = (
    selectedAssessmentItem.mappedAssignments || []
  ).map(({ id }) => id);

  return assignments.filter(({ id }) => mappedAssignmentsIds.includes(id));
};

export default filterMappedAssignments;
